export interface IDealConversionResponse {
  dealsGrouped: IDealsGroupedDataModel[];
  conversionRates: IConversionRateDataModel[];
}

export interface IConversionRateDataModel {
  stage: string;
  numOfDeals: number;
  previousPeriodDifference: number | null;
  track: number;
  pass: number;
  missed: number;
  conversionRate?: number | null;
  averageDuration?: number;
  missedPreviousPeriodDifference?: number | null;
  passPreviousPeriodDifference?: number | null;
  trackPreviousPeriodDifference?: number | null;
  stageSortOrder?: number;
}

export interface IDealsGroupedDataModel {
  name: string;
  value: number;
  percentageDifference: number | null;
}

export function createConversionRateDataModel(
  overrides: Partial<IConversionRateDataModel> = {}
): IConversionRateDataModel {
  return {
    stage: '',
    numOfDeals: 0,
    previousPeriodDifference: null,
    track: 0,
    pass: 0,
    missed: 0,
    conversionRate: null,
    averageDuration: 0,
    ...overrides,
  };
}

export function createDealsGroupedDataModel(
  overrides: Partial<IDealsGroupedDataModel> = {}
): IDealsGroupedDataModel {
  return {
    name: '',
    value: 0,
    percentageDifference: null,
    ...overrides,
  };
}
